module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('b-modal', {
    ref: "missionEditModal",
    attrs: {
      "id": "missionEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionEditTitleState,
      "feedback": _vm.missionEditTitleFeedback,
      "description": _vm.$t('mission.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.title),
      callback: function($$v) {
        _vm.missionEditData.title = $$v
      },
      expression: "missionEditData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.description'),
      "state": _vm.missionEditDescriptionState,
      "feedback": _vm.missionEditDescriptionFeedback,
      "description": _vm.$t('mission.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.description),
      callback: function($$v) {
        _vm.missionEditData.description = $$v
      },
      expression: "missionEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.detailedDescription'),
      "state": _vm.missionEditDetailedDescriptionState,
      "feedback": _vm.missionEditDetailedDescriptionFeedback,
      "description": _vm.$t('mission.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionEditDetailedDescriptionQuillEditorOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.detailedDescription),
      callback: function($$v) {
        _vm.missionEditData.detailedDescription = $$v
      },
      expression: "missionEditData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.collapsedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.collapsedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditcollapsedDescriptionEditor",
    attrs: {
      "options": _vm.missionEditDetailedDescriptionQuillEditorOptions
    },
    model: {
      value: (_vm.missionEditData.collapsedDescription),
      callback: function($$v) {
        _vm.missionEditData.collapsedDescription = $$v
      },
      expression: "missionEditData.collapsedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slottingTime'),
      "state": _vm.missionEditSlottingTimeState,
      "feedback": _vm.missionEditSlottingTimeFeedback,
      "description": _vm.$t('mission.slottingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.slottingTime),
      callback: function($$v) {
        _vm.missionEditData.slottingTime = $$v
      },
      expression: "missionEditData.slottingTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.startTime'),
      "state": _vm.missionEditStartTimeState,
      "feedback": _vm.missionEditStartTimeFeedback,
      "description": _vm.$t('mission.startTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.startTime),
      callback: function($$v) {
        _vm.missionEditData.startTime = $$v
      },
      expression: "missionEditData.startTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.endTime'),
      "state": _vm.missionEditEndTimeState,
      "feedback": _vm.missionEditEndTimeFeedback,
      "description": _vm.$t('mission.endTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.endTime),
      callback: function($$v) {
        _vm.missionEditData.endTime = $$v
      },
      expression: "missionEditData.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.briefingTime'),
      "state": _vm.missionEditBriefingTimeState,
      "feedback": _vm.missionEditBriefingTimeFeedback,
      "description": _vm.$t('mission.briefingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.briefingTime),
      callback: function($$v) {
        _vm.missionEditData.briefingTime = $$v
      },
      expression: "missionEditData.briefingTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.techSupport.optional'),
      "state": "success",
      "description": _vm.$t('mission.techSupport.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditTechSupportEditor",
    attrs: {
      "options": _vm.missionEditQuillEditorOptions
    },
    model: {
      value: (_vm.missionEditData.techSupport),
      callback: function($$v) {
        _vm.missionEditData.techSupport = $$v
      },
      expression: "missionEditData.techSupport"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.rules.optional'),
      "state": "success",
      "description": _vm.$t('mission.rules.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditRulesEditor",
    attrs: {
      "options": _vm.missionEditQuillEditorOptions
    },
    model: {
      value: (_vm.missionEditData.rules),
      callback: function($$v) {
        _vm.missionEditData.rules = $$v
      },
      expression: "missionEditData.rules"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.hostname.optional'),
      "state": _vm.missionEditGameServerHostnameState,
      "feedback": _vm.missionEditGameServerHostnameFeedback,
      "description": _vm.$t('mission.gameServer.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.gameServer.hostname),
      callback: function($$v) {
        _vm.missionEditData.gameServer.hostname = $$v
      },
      expression: "missionEditData.gameServer.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.hostname.optional'),
      "state": _vm.missionEditVoiceCommsHostnameState,
      "feedback": _vm.missionEditVoiceCommsHostnameFeedback,
      "description": _vm.$t('mission.voiceComms.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.hostname),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.hostname = $$v
      },
      expression: "missionEditData.voiceComms.hostname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.port.optional'),
      "state": _vm.missionEditGameServerPortState,
      "feedback": _vm.missionEditGameServerPortFeedback,
      "description": _vm.$t('mission.gameServer.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionEditData.gameServer.port),
      callback: function($$v) {
        _vm.missionEditData.gameServer.port = $$v
      },
      expression: "missionEditData.gameServer.port"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.port.optional'),
      "state": _vm.missionEditVoiceCommsPortState,
      "feedback": _vm.missionEditVoiceCommsPortFeedback,
      "description": _vm.$t('mission.voiceComms.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.port),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.port = $$v
      },
      expression: "missionEditData.voiceComms.port"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.gameServer.name),
      callback: function($$v) {
        _vm.missionEditData.gameServer.name = $$v
      },
      expression: "missionEditData.gameServer.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.name),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.name = $$v
      },
      expression: "missionEditData.voiceComms.name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.gameServer.password),
      callback: function($$v) {
        _vm.missionEditData.gameServer.password = $$v
      },
      expression: "missionEditData.gameServer.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.password),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.password = $$v
      },
      expression: "missionEditData.voiceComms.password"
    }
  })], 1)], 1)]), _vm._v(" "), ((_vm.communityGameServers && _vm.communityGameServers.length > 0) || (_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.communityGameServers && _vm.communityGameServers.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.gameServers'),
      "state": "success",
      "description": _vm.$t('community.gameServers.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionEditCommunityGameServers
    },
    model: {
      value: (_vm.missionEditCommunityGameServersSelected),
      callback: function($$v) {
        _vm.missionEditCommunityGameServersSelected = $$v
      },
      expression: "missionEditCommunityGameServersSelected"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [(_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.voiceComms'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionEditCommunityVoiceComms
    },
    model: {
      value: (_vm.missionEditCommunityVoiceCommsSelected),
      callback: function($$v) {
        _vm.missionEditCommunityVoiceCommsSelected = $$v
      },
      expression: "missionEditCommunityVoiceCommsSelected"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionEditVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.visibility),
      callback: function($$v) {
        _vm.missionEditData.visibility = $$v
      },
      expression: "missionEditData.visibility"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotsAutoAssignable'),
      "state": "success",
      "description": _vm.$t('mission.slotsAutoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditData.slotsAutoAssignable),
      callback: function($$v) {
        _vm.missionEditData.slotsAutoAssignable = $$v
      },
      expression: "missionEditData.slotsAutoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.aow = $$v
      },
      expression: "missionEditRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.apex = $$v
      },
      expression: "missionEditRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.contact = $$v
      },
      expression: "missionEditRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.csla = $$v
      },
      expression: "missionEditRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.gm = $$v
      },
      expression: "missionEditRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.helicopters = $$v
      },
      expression: "missionEditRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.jets = $$v
      },
      expression: "missionEditRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.karts = $$v
      },
      expression: "missionEditRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionEditRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.marksmen = $$v
      },
      expression: "missionEditRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.tacops = $$v
      },
      expression: "missionEditRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.tanks = $$v
      },
      expression: "missionEditRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.vn = $$v
      },
      expression: "missionEditRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.ef),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.ef = $$v
      },
      expression: "missionEditRequiredDLCs.ef"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/ef.png",
      "width": "16px",
      "alt": "Expeditionary Forces"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.ef')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.rf),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.rf = $$v
      },
      expression: "missionEditRequiredDLCs.rf"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/rf.png",
      "width": "16px",
      "alt": "Reaction Forces"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.rf')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditSuppressNotifications),
      callback: function($$v) {
        _vm.missionEditSuppressNotifications = $$v
      },
      expression: "missionEditSuppressNotifications"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08e8628c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionEditModal.vue
// module id = 468
// module chunks = 0